module.exports = __webpack_public_path__ + "img/proudly-subtitle-two.d5f46d6d.png";